const BASE_TEST_API_URL = 'http://localhost:3000/api';
const BASE_API_URL = '/api';

export type BaseServiceUrls =
  | '/roster'
  | '/auth'
  | '/search'
  | '/construct'
  | '/session'
  | '/fulfillment'
  | '/data';

export type Version = '/v1' | '/v2' | '/v3';

export type QueryParameters = Record<string, string | string[] | undefined>;

export function buildUrl(
  endpoint: `/${string}`,
  service: BaseServiceUrls = '/data',
  version: Version = '/v1',
  queryParameters?: QueryParameters
) {
  const base = import.meta.env.TEST ? BASE_TEST_API_URL : BASE_API_URL;
  const params = new URLSearchParams();
  Object.entries(queryParameters ?? {}).forEach(([key, value]) => {
    if (value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else {
      params.append(key, value);
    }
  });
  const queryString = params.toString();
  return (
    base + service + version + endpoint + (queryString ? `?${queryString}` : '')
  );
}

export async function fetcher<TResponse = unknown>(
  endpoint: `/${string}`,
  config?: RequestInit & {
    service?: BaseServiceUrls;
    version?: Version;
    queryParameters?: QueryParameters;
  }
) {
  const { service, version, queryParameters, ...rest } = config ?? {};

  const response = await fetch(
    buildUrl(endpoint, service, version, queryParameters),
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      ...rest,
    }
  );

  if (response.ok) {
    return response.json() as TResponse;
  }

  throw new Error(`Response was not ok - ${response.status}`);
}
